
















import { Component, Vue } from 'vue-property-decorator'

@Component({
  name: 'IcnIndustry'
})
export default class IcnIndustry extends Vue {
}
